import { FETCH_DEFECT_SOLUTIONS } from "./actions.type";

import { FETCH_START } from "./mutations.type";
import { DefectSolutionsService } from "../../common/defectSolutions.service";

const state = {
    allSolutions: []
};

const getters = {
    allSolutions(state) {
        return state.allSolutions;
    }
};

const actions = {
    [FETCH_DEFECT_SOLUTIONS]({ commit }) {
        commit(FETCH_START);
        return DefectSolutionsService.query()
            .then(({ data }) => {
                commit(FETCH_DEFECT_SOLUTIONS, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    }
};

const mutations = {
    [FETCH_START](state) {
        state.isLoading = true;
    },
    [FETCH_DEFECT_SOLUTIONS](state, solutions) {
        solutions.push({ value: -1, text: "Iné" });
        state.allSolutions = solutions;
        state.isLoading = false;
    }
};
export default {
    getters,
    actions,
    state,
    mutations
};
